import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'
import { safeAlpha, safeDarken } from '../../../utils/color'

export const Idiv = styled.div``
export const Ia = styled.a``

// Avatar de AvatarCell (Storybook de Velora): 40 px; las iniciales van sobre un tinte
// suave del color del cliente para que se lean con cualquier color de marca.
export const MTImageStyled = styled.div`
  flex-shrink: 0;
  font-family: ${tokens.typography.fontFamily.primary};
  font-weight: 500 !important;
  letter-spacing: 0.5px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => safeAlpha(props.theme.primary, 0.14)};
  background-position: center center;
  background-size: cover;
  line-height: 40px;
  color: ${props => safeDarken(props.theme.primary, 0.45)};
  font-size: 14px;
  margin-right:  ${props => props.size === 'big' ? 'auto' : '12px'};
  margin-left: ${props => props.size === 'big' ? 'auto' : '0px'};
  text-align:center;

  /* Avatar de la ficha: tamaño fijo (antes 6vw, que crecía con la pantalla) */
  &.big {
    font-size: 38px;
    font-weight: 600 !important;
    letter-spacing: 1px;
    width: 120px;
    height: 120px;
    line-height: 120px;
  }
`
